const theme = {
  colors: {
    primary: '#FFD700', // Vibrant gold
    secondary: '#FDF5E6', // Elegant old lace
    accent: '#B22222', // Firebrick red
    text: '#1C1C1C', // Rich black
    background: 'linear-gradient(135deg, #FAF3E0 0%, #FFFFFF 100%)', // Soft gold-toned gradient
    gold: {
      light: '#FFEC8B', // Light goldenrod
      medium: '#FFD700', // Pure gold
      dark: '#B8860B', // Dark goldenrod
    },
    red: {
      light: '#FF6347', // Tomato red
      medium: '#B22222', // Firebrick red
      dark: '#800000', // Deep maroon
    },
    gradients: {
      primary: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', // Gold to warm orange
      secondary: 'linear-gradient(135deg, #8B0000 0%, #FF4500 100%)', // Deep red to fiery orange
      background: 'linear-gradient(135deg, #FAF3E0 0%, #FFFFFF 100%)', // Creamy gold fade
      card: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.75) 100%)', // Subtle glossy white
    }
  },
  fonts: {
    primary: "'Playfair Display', serif", // Elegant, luxury-style font
    secondary: "'Montserrat', sans-serif", // Modern and clean
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px'
  },
  spacing: {
    xs: '0.25rem',
    small: '0.5rem',
    medium: '1rem',
    large: '2rem',
    xlarge: '4rem'
  },
  shadows: {
    soft: '0 6px 12px rgba(0, 0, 0, 0.05)',
    medium: '0 10px 20px rgba(0, 0, 0, 0.1)',
    strong: '0 14px 28px rgba(0, 0, 0, 0.2)',
    gold: '0 5px 15px rgba(255, 215, 0, 0.5)' // Glow effect for gold elements
  },
  borders: {
    gold: '2px solid #FFD700',
    light: '1px solid rgba(255, 215, 0, 0.4)'
  },
  effects: {
    glassmorphism: `
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 215, 0, 0.3);
      box-shadow: 0 4px 10px rgba(255, 215, 0, 0.2);
      border-radius: 12px;
    `,
    shine: `
      &:after {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: linear-gradient(
          to right,
          transparent 0%,
          rgba(255,255,255,0.3) 50%,
          transparent 100%
        );
        transform: rotate(30deg);
        animation: shine 3s infinite linear;
      }
      @keyframes shine {
        from {
          transform: translateX(-100%) rotate(30deg);
        }
        to {
          transform: translateX(100%) rotate(30deg);
        }
      }
    `,
    glow: `
      box-shadow: 0 0 15px rgba(255, 215, 0, 0.6), 
                  0 0 30px rgba(255, 215, 0, 0.3);
    `
  },
  animations: {
    easeOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    duration: '0.3s',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    smooth: 'cubic-bezier(0.23, 1, 0.32, 1)', // Extra smooth effect
  }
};

export default theme;
